import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/orders/managing-docs-for-orders/global'

export const MANAGING_DOCS_FOR_ORDERS_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
